import { render, staticRenderFns } from "./OrdersMy.vue?vue&type=template&id=148c68b6"
import script from "./OrdersMy.vue?vue&type=script&lang=js"
export * from "./OrdersMy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports